export interface NavItem {
  id: string;
  label: string;
  href?: string | null;
  landingSection?: LandingSection;
  targetScreen?: string;
  disabled?: boolean;
}

export type LandingSection = 'how' | 'reviews' | 'benefits';

export function helpUrl(role?: string | null) {
  return role === 'carrier' ? '/portal/#carrier-help' : role === 'customer' ? '/portal/#customer-help' : '/#guest-help';
}

export function landingSectionUrl(section: LandingSection) {
  return `/#landing?section=${section}`;
}

export function navigateToLandingSection(section: LandingSection) {
  const targetHash = `#landing?section=${section}`;

  if (window.location.pathname.startsWith('/portal')) {
    window.location.assign(`/${targetHash}`);
    return;
  }

  if (window.location.hash === targetHash) {
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  window.location.hash = targetHash;
}

export const MAIN_NAV_ITEMS: NavItem[] = [
  { id: 'how-it-works', label: 'Как это работает', href: landingSectionUrl('how'), landingSection: 'how' },
  { id: 'why-lovo', label: 'Почему LOVO', href: landingSectionUrl('benefits'), landingSection: 'benefits' },
  { id: 'reviews', label: 'Отзывы', href: landingSectionUrl('reviews'), landingSection: 'reviews' },
  { id: 'help', label: 'Помощь', href: helpUrl() },
];

export function handleNavClick(
  item: NavItem,
  onNavigate?: (screen: string) => void,
  event?: React.MouseEvent
) {
  if (item.disabled || !item.href) {
    if (event) event.preventDefault();
    return;
  }

  if (item.landingSection) {
    event?.preventDefault();
    navigateToLandingSection(item.landingSection);
    return;
  }

  if (item.targetScreen && onNavigate) onNavigate(item.targetScreen);
}
